/* ai-collapse.tsx generated by @compiled/babel-plugin v0.38.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./ai-collapse.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { forwardRef, useRef } from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import { cx } from '@atlaskit/css';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';
import { Box, Inline } from '@atlaskit/primitives/compiled';
import { useAIAnswerContext } from '../../../ai-answer-dialog/ai-answer-context';
import { aiAnswerCollapseClicked, aiAnswerExpandClicked } from '../../../ai-answer-dialog/analytics';
import { useAnalytics } from '../../../common';
import { SainAction, useSAINUsageCriteriaMet } from '../../../common/controller/analytics/hooks/use-sain-usage';
import { QueryIntent } from '../../../constants';
import { messages } from './messages';
var styles = {
  collapsableContainer: "_1reo15vq _18m915vq _19bvpxbi _u5f3pxbi _ca0qu2gc",
  header: "_19bvpxbi _u5f3pxbi _ca0qutpp",
  pointer: "_80omtlke",
  rootCollapsed: "_4t3i68cl _1nwp1n9w",
  rootCollapsedWithReadMore: "_1reo15vq _18m915vq _4t3iucft _1bto1l2s _o5721q9c _1nwp1n9w",
  rootExpanded: "_1tke1k53",
  explicitQuestionCollapsed: "_4t3i1ogy _1nwp1n9w",
  explicitQuestionCollapsedWithReadMore: "_4t3i1018 _1bto1l2s _o5721q9c _1nwp1n9w",
  explicitQuestionExpanded: "_1tke1q9m",
  pressable: "_bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _80om73ad _1bsb1osq"
};
export var AICollapse = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var children = _ref.children,
    isCollapsed = _ref.isCollapsed,
    onExpandCollapse = _ref.onExpandCollapse,
    title = _ref.title,
    showReadMoreButton = _ref.showReadMoreButton,
    queryIntent = _ref.queryIntent;
  var containerRef = useRef(null);
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes;
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var onExpand = function onExpand() {
    fireAnalyticsEvent(aiAnswerExpandClicked(commonAttributes));
    fireSAINUsageEvent({
      metCriteria: SainAction.EXPAND_CLICKED,
      commonAttributes: commonAttributes
    });
  };
  var onCollapse = function onCollapse() {
    return fireAnalyticsEvent(aiAnswerCollapseClicked(commonAttributes));
  };
  var handleExpandCollapse = function handleExpandCollapse() {
    if (isCollapsed) {
      onExpand();
    } else {
      onCollapse();
    }
    onExpandCollapse === null || onExpandCollapse === void 0 || onExpandCollapse();
  };
  var handleExpandCollapseButtonClick = function handleExpandCollapseButtonClick(event) {
    event.stopPropagation();
    handleExpandCollapse === null || handleExpandCollapse === void 0 || handleExpandCollapse();
  };
  var onContainerClick = function onContainerClick(event) {
    var _window$getSelection$, _window$getSelection, _containerRef$current, _containerRef$current2;
    var selection = (_window$getSelection$ = (_window$getSelection = window.getSelection()) === null || _window$getSelection === void 0 ? void 0 : _window$getSelection.toString()) !== null && _window$getSelection$ !== void 0 ? _window$getSelection$ : '';
    // Highlighting text should not expand the card
    var hasHighlightedText = selection.length > 0;
    // Clicking in a feedback modal or flag should not expand the card
    var isClickingOnContainer = (_containerRef$current = (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.contains(event.target)) !== null && _containerRef$current !== void 0 ? _containerRef$current : false;
    if (isCollapsed && !hasHighlightedText && isClickingOnContainer) {
      handleExpandCollapse === null || handleExpandCollapse === void 0 || handleExpandCollapse();
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    onClick: onContainerClick,
    ref: containerRef,
    xcss: cx(styles.pressable, isCollapsed && styles.pointer)
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    spread: "space-between",
    xcss: styles.header
  }, title, /*#__PURE__*/React.createElement(IconButton, {
    appearance: "subtle",
    icon: isCollapsed ? ChevronDownIcon : ChevronUpIcon,
    label: formatMessage(isCollapsed ? messages.ai_answer_card_expand_button : messages.ai_answer_card_collapse_button),
    spacing: "compact",
    onClick: handleExpandCollapseButtonClick
  })), /*#__PURE__*/React.createElement(Box, {
    ref: forwardedRef,
    xcss: cx(styles.collapsableContainer, queryIntent === QueryIntent.EXPLICIT_QUESTION ? isCollapsed ? showReadMoreButton ? styles.explicitQuestionCollapsedWithReadMore : styles.explicitQuestionCollapsed : styles.explicitQuestionExpanded : isCollapsed ? showReadMoreButton ? styles.rootCollapsedWithReadMore : styles.rootCollapsed : styles.rootExpanded),
    testId: "ai-collapse-container"
  }, children));
});